<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            style="height: 100%"
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <div class="dataLeft">
              <div class="dirTop">
                <el-scrollbar>
                  <tree
                    :isSearch="isSearch"
                    @initFun="initQuery"
                    @nodeClick="nodeClick"
                  ></tree>
                </el-scrollbar>
              </div>
              <div class="dirBottom">
                <el-input
                  style="width: 96%"
                  class="inputStyle"
                  @keyup.enter.native="onkeyUp"
                  v-model="carIdInput"
                  size="small"
                  :placeholder="$t('common.searchTip')"
                ></el-input>
                <i-table
                  :list="list"
                  :height="height"
                  ref="carTable"
                  :options="option"
                  :columns="columns"
                  :operates="operates"
                  @rowClick="rowClick"
                ></i-table>
                <IPagination ref="page" @PageFun="changeSize"></IPagination>
              </div>
            </div>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="dataRight">
        <div class="stateTable">
          <el-scrollbar>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane name="first"
                ><span slot="label"
                  ><i class="iconfont icon-shijianchuo"></i>{{$t('common.nearlyMonth')}}</span
                >
                <div v-if="'first' === activeName">
                  <MonthTime ref="monthTime" :bind-car="carId"></MonthTime>
                </div>
              </el-tab-pane>
              <el-tab-pane name="second"
                ><span slot="label"
                  ><i class="iconfont icon-benyue"></i>{{$t('common.choseTime')}}</span
                >
                <div v-if="'second' === activeName">
                  <ChangeTime ref="changeTime" :bind-car="carId"></ChangeTime>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fault from "./Fault.js";
export default Fault;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
</style>
